import '../../machinesranking/wizard/Main.css'
import './Main.css'

import React from 'react'
import { Spinner } from '@/components/spinner'
import { useWizard, WizardProvider } from '@/common/wizard/wizard'
import { cleanWizardData, WizardData } from './Model'
import { FleetUtilizationWizardStep1 } from './Step1'
import { FleetUtilizationWizardResult } from './Result'
import { MachinesReportWizardSelection } from '../../machinesranking/wizard/Selection'
import { FleetUtilizationExports } from './Exports'

const FleetUtilizationWizardBody = () => {
  const { step, wizardData } = useWizard<WizardData>()
  if (step === 0) return <FleetUtilizationWizardStep1 />
  if (step === 1 && wizardData.selectMachines) return <MachinesReportWizardSelection optionsURL='/api/communal/my/reports/fleetutilization/options' exports={FleetUtilizationExports} />
  if (step === 1 || step === 2) return <FleetUtilizationWizardResult />
  return <Spinner />
}

export const FleetUtilizationWizard = () => <div className='machinesranking-wizard fleetutilization-wizard'>
  <WizardProvider<WizardData> initialData={cleanWizardData()} maxStep={2}><FleetUtilizationWizardBody /></WizardProvider>
</div>

export const FleetUtilizationWizardPopup = ({ onClose: _onClose }: { onClose: () => void }) => <FleetUtilizationWizard />
